export default __webpack_public_path__ + "static/media/ic_warning.db02a9e5.svg";